import React from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { mapsLayers, mapsTile } from './mapsLayers';

const MapCustomLayerControl = ({ layersControlPosition = 'topright', defaultCollapsed = false }) => {
  const map = useMap();

  React.useEffect(() => {
    L.control.layers(mapsTile, mapsLayers, {
      collapsed: defaultCollapsed,
      position: layersControlPosition,
    }).addTo(map);
  }, [layersControlPosition, defaultCollapsed, map]);

  React.useEffect(() => {
    mapsTile['Open Street Map'].addTo(map);
  }, [map]);

  return null;
};

export default MapCustomLayerControl;
